import { Dispatch } from 'react';
import { GenericTableAction } from './genericTableReducer';
import { fetchPreferences } from '../../helpers/uiPreferencesHelpers';

export const getPreferences = async (
  userPreferenceSource: string,
  dispatch: Dispatch<GenericTableAction>
) => {
  const { res: globalRes } = await fetchPreferences('universal');
  const { ui_preferences: [globalPreferences] = [] } = globalRes;
  const { res: localRes } = await fetchPreferences(userPreferenceSource);
  const { ui_preferences: [localPreferences] = [] } = localRes;
  globalPreferences?.columns?.density &&
    dispatch({ type: 'SET_DENSITY', payload: globalPreferences?.columns?.density });
  localPreferences?.sortable_columns &&
    dispatch({ type: 'SET_COLUMNS', payload: localPreferences?.sortable_columns });
  localPreferences?.row_count &&
    dispatch({ type: 'SET_LIMIT', payload: localPreferences?.row_count });
  localPreferences?.sorting?.sortBy &&
    dispatch({
      type: 'SET_SORT',
      payload: {
        sortBy: localPreferences?.sorting?.sortBy,
        sortOrder: localPreferences?.sorting?.sortOrder || 'desc'
      }
    });
  return null; // need to return something to satisfy the useQuery hook
};
